import axios from 'axios'

const axiosInstance = axios.create({
  timeout: 50000,
})

axiosInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token') || ''
  if (token) {
    config.headers['X-Access-Token'] = token
  }
  return config
}, function (err) {
  return Promise.reject(err)
})

export default axiosInstance
